import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import SelectContactLoggedInScreen from '../../pages/mobile/sign-up/loggedin/SelectContactLoggedInScreen';
import UseDifferentNumberScreen from '../../pages/mobile/sign-up/loggedin/UseDifferentNumberScreen';
import ThankYouScreen from '../../pages/mobile/sign-up/ThankYouScreen';

function MobileSignupLoggedInLayout() {

  return (
    < >
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
            <Switch>
              <Route path="/sign-up/loggedin/thank-you">
                <ThankYouScreen />
              </Route>
              <Route path="/sign-up/loggedin/use-different-number">
                <UseDifferentNumberScreen />
              </Route>
              <Route path="/sign-up/loggedin">
                <SelectContactLoggedInScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileSignupLoggedInLayout;
